import { css, Global } from '@emotion/react';
import { memo } from 'react';

import type { Color } from '@didaskill/types/web';

export const createThemeGlobalStyles = (themeColors: Record<string, Color>) => {
  return memo(() => (
    <Global
      styles={css`
      @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Nunito:ital,wght@0,200..1000;1,200..1000&family=Source+Code+Pro:wght@500;600;700&display=swap');

      /* Reset gutters. */
      *,
      *::after,
      *::before {
        padding: 0;
        margin: 0;
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        font-family: Montserrat, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        height: 100%;
        width: 100%;

        color: ${themeColors.gray[700]};
      }

      mark {
        background-color: inherit;
        color: inherit;
      }

      .ReactCollapse--collapse {
        transition: height 250ms;
      }
    `}
    />
  ));
};
